// ==============================
// 파일명 : src/utils/users.js
// 역할 : 유저 보유팩/표시명/업데이트 기록 및 UID 정규화를
//         담당하는 공용 로직을 제공
// 수정일 : 2025-10-13
// ==============================


export const normalizePackIds = (ids) => {
  const source = Array.isArray(ids) ? ids : []; // [수정] 입력 배열을 안전하게 취득
  const filtered = source.filter(Boolean); // [수정] falsy 값을 제거
  const unique = Array.from(new Set(filtered)); // [수정] 중복을 제거
  return unique; // [수정] 정규화된 packId 배열 반환
}; // [수정] 언어팩 ID 배열을 정규화한다.

export const arePackIdListsEqual = (left, right) => {
  const a = [...normalizePackIds(left)].sort(); // [수정] 좌측 배열 정렬
  const b = [...normalizePackIds(right)].sort(); // [수정] 우측 배열 정렬
  if (a.length !== b.length) return false; // [수정] 길이 차이면 변경 발생
  return a.every((value, index) => value === b[index]); // [수정] 동일 여부 확인
}; // [수정] 두 언어팩 배열의 동일성을 비교한다.

export const markOwnedPackActivityTime = () => Date.now(); // [수정] 보유팩 활동 시각 생성

export const extractOwnedPackIds = (user) => {
  if (!user) return []; // [수정] 사용자 미존재 시 빈 배열 반환
  const candidates =
    user.ownedPacks ||
    user.ownedPackIds ||
    user.packs ||
    user.purchased_packs ||
    []; // [수정] 다양한 필드에서 후보군 수집
  return normalizePackIds(candidates); // [수정] 정규화된 보유팩 ID 반환
}; // [수정] 유저 객체에서 보유 언어팩 ID를 추출한다.

export const makePackLabel = (pack) => {
  if (!pack) return ""; // [수정] 팩 정보 없음 처리
  const name = pack.name || "(no-name)"; // [수정] 이름 보강
  const lang = pack.language ? ` / ${pack.language}` : ""; // [수정] 언어 표기
  const type = pack.type ? ` (${pack.type})` : ""; // [수정] 타입 표기
  return `${name}${lang}${type}`; // [수정] 최종 라벨 반환
}; // [수정] 언어팩 라벨 문자열을 구성한다.

// [수정] 유저 표시명을 일관되게 생성한다.
export const displayNameOf = (user) => {
  if (!user) return "-"; // [수정] 사용자 없음 처리
  return user.displayName || user.name || user.email || "-"; // [수정] 표시명 우선순위 적용
}; // [수정] 유저 표시명을 일관되게 생성한다.

export const normalizeAuthUid = (candidate, fallback = "") => {
  const primary = typeof candidate === "string" ? candidate.trim() : ""; // [수정] 기본 UID 후보 정리
  if (primary) return primary; // [수정] 올바른 UID가 있으면 즉시 반환
  const secondary = typeof fallback === "string" ? fallback.trim() : ""; // [수정] 보조 UID 후보 정리
  return secondary; // [수정] 보조 후보 또는 빈 문자열 반환
}; // [수정] Firebase UID 입력값을 일관되게 정규화한다.